import styled from "styled-components"
import {Label1} from "@irati/ui/src/Labels"
import {greys} from "@irati/ui/src/global/colors"
import BrandLineBase from "@irati-web/platform/src/components/Header/shared/BrandLine"

export const HeaderBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  height: 70px;
`

export const MockPBLogo = styled.img`
  height: 40px;
`

export const DottedBrandLine = styled.div`
  height: 10px;
  border-top: 2px dotted ${greys.medium};
  border-bottom: 2px dotted ${greys.medium};
`

export const DottedLogo = styled.div`
  display: flex;
  height: 40px;
  width: 150px;
  border: 2px dotted ${greys.medium};
`

export const LogoText = styled(Label1)`
  margin: auto;
  text-align: center;
`

export const BrandLine = styled(BrandLineBase)`
  z-index: auto;
`